<template>
  <!-- 95% height to ensure no scroll bar -->
  <apexcharts ref="chart" :height="height" :options="options" :series="series"></apexcharts>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import chartOptions from '@/library/graphs/ChartOptions';
import linq from '../../library/linq';

export default {
  name: 'elevation-profile',
  props: {
    points: {
      type: Array,
      required: false,
      default: () => [],
    },
    height: {
      type: [String, Number],
      required: false,
      default: '95%',
    },
  },
  components: {
    apexcharts: VueApexCharts,
  },
  data: () => ({
    options: {},
    series: [{ data: [] }],
  }),
  watch: {
    points() {
      this.render();
    },
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      if (this.points.length > 0) {
        const max = 1000;
        const pointData = [];
        const y = [];
        const n = Math.ceil(this.points.length / max);
        linq.takeNth(this.points,n).every((p) => pointData.push([p.distance, p.altitude]));
        this.series = [{ name: 'Elevation', data: pointData, markers: { colors: ['#dd750f'] }, type: 'area' }];
        this.options = chartOptions.getElevationOptions();
      }
    },
  },
};
</script>

